/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type { Database } from "../../../__definitions__/database-definitions";
import {
  SupabaseService,
  SupabaseServiceView,
  type GetAllOptions,
} from "../../../server/supabase/base-supabase-service";
import type { UUID } from "../../../utils/uuid";

export type ReviewStatus =
  Database["public"]["Tables"]["moment_review_log"]["Row"]["review_status"];

export type MomentReviewLogEntry = Database["public"]["Tables"]["moment_review_log"]["Row"];

/** Where a Communication's review got to, worked out by the database. */
export type MomentReviewState = Database["public"]["Views"]["moment_review_state"]["Row"];

export type ReviewStep = {
  moment_id: UUID;
  review_status: ReviewStatus;
  reviewer_person_id?: UUID | null;
  note?: string | null;
};

export class SupabaseMomentReviewLogService extends SupabaseService<"moment_review_log"> {
  table = "moment_review_log" as const;

  // The log only holds a moment_id, so join the moments view for the title and the current
  // moment/review status.
  getAllWithMoment(account_id: UUID, options: GetAllOptions<MomentReviewLogEntry>) {
    return this.getAllFromSelection(
      account_id,
      this.client
        .from(this.table)
        .select(
          "moment_id, created_at, note, user_name, moment:moments!moment_review_log_account_id_moment_id_fkey(title, status, review_status)",
        ),
      options,
    );
  }
}

export class SupabaseMomentReviewStateService extends SupabaseServiceView<"moment_review_state"> {
  table = "moment_review_state" as const;
}
